import { TypographyP } from "./ui/typography";

export default function BackToTop() {
  return (
    <TypographyP className="text-center">
      Back to <a href="#top">top</a>.
    </TypographyP>
  );
}
